/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { CoreNetworking, type ApiClient } from '@airasia-rn/ui/core-networking';
import { Station } from '../models';
import { Environment } from './avalonApiService';

function getHost(environment: Environment, providedHost?: string): string {
  if (providedHost) return providedHost;
  return environment === 'prd' ? 'static.airasia.com' : 'static.stgairasia.com';
}

export class StationsApiService {
  private readonly client: ApiClient;

  constructor(
    private environment: Environment,
    private clientHost?: string,
  ) {
    this.client = CoreNetworking({
      baseUrl: `https://${getHost(this.environment, this.clientHost)}`,
    });
  }

  async fetchStations(local: string = 'en-gb'): Promise<Station[]> {
    const response = await this.client.get(
      `/flights/station/v3/${local}/file.json`,
    );
    return response.data;
  }
}
